// extracted by mini-css-extract-plugin
export var inline = "_tt-0";